export default "__VITE_ASSET__59637742__"